// src/web/components/chat-message-item.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import connect from '../../connects/chat-message-item'
import Chip from 'react-toolbox/lib/chip'
import Avatar from 'react-toolbox/lib/avatar'
import Link from 'react-toolbox/lib/link'
import _ from 'lodash'
import { urlRegex } from '../../helpers/url-regexp'
import { convertEmojiHTML } from '../../helpers/emoji-helpers'
import classnames from 'classnames'
import chatMessageTheme from './themes/chat-message.css'
import avatarTheme from './themes/tiny-avatar.css'
import { InviewSensor } from './infinite-scroller'
import Tooltip from 'react-toolbox/lib/tooltip'
import AttachmentsTheme from './themes/attachments.css'
import isGoogleDocUrl from '../../helpers/google-doc'
import isGambaUrl from '../../helpers/gamba-url'
import ConfirmDialog from './confirm-dialog.jsx'
import FontIcon from 'react-toolbox/lib/font_icon'
import VideoViewer from './video-viewer.jsx'
import AttachmentFile from './attachment-file.jsx'
import PdfPreviewDialog from './pdf-preview-dialog'
import UserDetailsModal from './user-details-modal'
import GoogleIcons from '../../assets/google-icons'
import emoji from '../../native/assets/emoji'
import {
  Button,
} from 'react-toolbox/lib/button'

const TooltipButton = Tooltip(Button)

const UrlRegex = urlRegex()

const TooltipLink = Tooltip(Link)

function replaceHref(match) {
  return '<a target="_blank" rel="noopener noreferrer" href="'+(match.match(/^http/) ? '' : 'http://')+match+'">'+
      (match.length > 80 ? match.slice(0, 30)+'...'+match.slice(match.length-20, match.length) : match)+'</a>';
}

class ChatMessageItem extends React.Component {
  state = { active: false, isConfirm: false, pdfThumbnail: true, isReactClicked: false}
  read = undefined

  renderGoogleDocUrl = (url)=> {
    const attach_json = this.props.message.attach_json && typeof this.props.message.attach_json == 'string' && JSON.parse(this.props.message.attach_json) || this.props.message.attach_json
    const urlLink = attach_json && attach_json.links[url]
    const image_url = urlLink && (urlLink.image_url || GoogleIcons[urlLink.mime_type || 'default'] || GoogleIcons['default'])
    var title = urlLink && urlLink.title || this.props.t('label:Googleドキュメント')
    title = title && title.length > 20 ? title.slice(0, 20) + "..." : title
    return `<div class=${!image_url && "googleDocIcon"}><a class=${image_url ? "googleDoc" : "googleDocIcon" } style="background-color: transparent; border-radius: 5px; padding: 3px 7px; text-decoration: none; font-size: 90%; display: inline-block; vertical-align: middle; height: 24px; margin-top: 1px;" href="${url}">`+
      (image_url ? `<img src=${image_url} style="height: 18px; vertical-align: middle;">` : '')+
      `&nbsp;${title}</a></div>`
  }

  renderGambaUrl =     (url)=> `<a class="gambaUrl" style="font-size: 90%; text-decoration: none; display: inline-block;" href="${url}"><span class="material-icons" style="font-size: 90%; padding: 0 5px; margin-top: 1px;">bookmark</span>&nbsp;${this.props.t('label:gambaで開く')}</a>`
  renderLink = (url)=> {
    const attach_json = this.props.message.attach_json && typeof this.props.message.attach_json == 'string' && JSON.parse(this.props.message.attach_json) || this.props.message.attach_json
    const urlLink = attach_json && attach_json.links[url]
    const image_url = urlLink && urlLink.image_url
    var title = urlLink && urlLink.title || isGambaUrl(url) && this.props.t('label:gambaで開く')
    title = title && title.length > 20 ? title.slice(0, 20) + "..." : title
    var disp_url = (url.length > 40 ? url.slice(0, 40) + "..." : url).replace(/^https?:\/\/(www\.)?/, '')
    const target = isGambaUrl(url) ? '' : 'target="_blank"'
    if (!title) {
      title = disp_url
      disp_url = undefined
    }
    if (isGambaUrl(url))
      disp_url = undefined
    return `<div style="display: ${!image_url && "inline-block;"}"><a ${target} class=${image_url ? "image" : "chatMaterialIcon"} rel="noopener noreferrer" style="background-color: transparent; border-radius: 5px; display: ${image_url ? "inline-block" : "flex"}; vertical-align: middle; text-decoration: none; padding: 0px 5px 0px 0px;" href="${url}">` +
        '<div style="display: flex; align-items: center;">' +
          (image_url ? `<img src="${image_url}" style="height: ${disp_url ? '32px' : '24px'}; border-radius: 5px; margin-right: 3px 5px;"/>` : '')+
          '<div style="display: flex; flex-direction: column; margin-left: 2px; text-indent: initial; line-height: 95%;">'+
            `<div style="font-size: 90%">${title}</div>`+
            (disp_url ? `<div style="font-size: 80%; color: #666;">${disp_url}</div>` : '')+
          '</div>'+
        '</div>'+
      '</a></div>'
  }

  componentDidMount() {
    const googleDocElements = ReactDOM.findDOMNode(this.component).querySelectorAll('a.googleDoc, a.googleDocIcon')
    _.each(googleDocElements, (element)=> {
      element.onclick = (event)=> {
        event.preventDefault()
        this.props.openDoc(element.href, true)
      }
    })
  }

  showImagesView = (image)=> this.props.showImagesView('CHAT_ROOM', this.props.message.chat_room_id, image)
  showPdfPreview = (pdf)=> {
    this.props.openPdf(pdf, true)
  }
  onPdfThumbnailError = ()=> this.setState({ pdfThumbnail: false })
  onCloseButton = ()=> this.setState({ active: true })
  offCloseButton = ()=> this.setState({ active: false })

  onLoad = (ev, video)=> {
    this.setState({ [`width${video.video_id}`]: ev.target.width, [`height${video.video_id}`]: ev.target.height })
  }

  deleteChatMessage = ()=> {
    this.props.deleteChatMessage(this.props.message.message_id)
    this.setState({ isConfirm: false })
  }

  cancelDeleteMessage = ()=> this.setState({ isConfirm: false })

  getSize = (image, clientWidth)=> {
    const width = !image.width ? this.state[`width${image.video_id}`] : image.width
    const height = !image.height ? this.state[`height${image.video_id}`] : image.height
    var wRatio = width > clientWidth * 0.6 ? clientWidth * 0.6 / width : 1.0
    var hRatio = (height * wRatio) > 300 ? 300 / (height * wRatio) : 1.0
    var ratio = 1.0

    if ( wRatio == 1.0 ) {
      if ( hRatio == 1.0 ) {
        ratio = 1.0
      }
      else {
        ratio = hRatio
      }
    }
    else {
      if ( hRatio == 1.0 ) {
        ratio = wRatio
      }
      else {
        ratio = wRatio * hRatio
      }
    }

    return  { width: width * ratio, height: height * ratio }
  }

  selectChatIcon = (user, chatRoomMember) => {
    const existsChatRoom = _.find(chatRoomMember, (member)=> member.user_id == user.user_id)
    existsChatRoom ? this.props.updateUI({ user: user, openDialog: true }) : this.props.notChatRoomMember()
    }

  handleReactclick = () => {
    this.setState((prevState) => {
      if (prevState.isReactClicked) return null; 
      this.props.reactionChat();
      return { isReactClicked: true }; 
    });
  
    setTimeout(() => this.setState({ isReactClicked: false }), 800); // Re-enable after delay
  };

  render() {
    const {
      t,
      ui,
      updateUI,
      user,
      message,
      withName,
      readMessage,
      showImagesView,
      chatPageWidth,
      deleteChatMessage,
      chatRoomMember,
      notChatRoomMember,
      individualChatRoom,
      pdfs,
      files,
      images,
      videos,
      audios,
      isMessage,
      openPdf,
      openDoc,
      reactionChat,
      likeConfig,
      theme,
    } = this.props

    const likes_count = message.likes? message.likes.length : 0

    const tooltip = message.likes.map((like)=>
      <div key={like.like_id}>
        <Avatar image={like.user.icon_image.thumb_url} theme={theme} />
        &nbsp;
        {like.user.name} &nbsp;
        {<img style={{ height: 16, width: 16 }} src={likeConfig && emoji[likeConfig[like.like_type].icon.replace('\\u','')]} />}
      </div>)

    /* 同じlike_typeが配列内にある場合は除外する */
    const likesArray = message.likes && message.likes.reduce((prev, current) => {
      if(!prev.some((e) => e.like_type === current.like_type)) {
        prev.push(current)
      }
      return prev
    }, [])

    const htmlContent = message.message && convertEmojiHTML(message.message.replace(UrlRegex, (match)=> {
      return (
        isGoogleDocUrl(match) && this.renderGoogleDocUrl(match) || this.renderLink(match)
      )
    })) || undefined
    const isStamp = message.message && message.message.match(/<span class=['"]stamp [-a-zA-Z0-9]+["']><\/span>/)
    const direction = this.props.direction ? 'right' : 'left'
    const hasRead = message.user && (message.user.user_id == user.user_id || message.readers && _.find(message.readers, (item)=> item.user_id == user.user_id)) || false

    const isReacted = message.likes.some((like) => like.user.user_id === user.user_id)

    var timeline_message
    if (message.message_type) {
      switch(message.message_type) {
        case 'member_added':
          timeline_message =  <div className={chatMessageTheme.divider}>
                                <span className={chatMessageTheme.span}>
                                  {t('label:メンバー入室', {name: message.user && message.user.name})}
                                </span>
                              </div>
          break
        case 'member_removed':
          timeline_message =  <div className={chatMessageTheme.divider}>
                                <span className={chatMessageTheme.span}>
                                  {t('label:メンバー退室', {name: message.user && message.user.name})}
                                </span>
                              </div>
          break
        case 'name_changed':
          timeline_message =  <div className={chatMessageTheme.divider}>
                                <span className={chatMessageTheme.span}>
                                  {t('label:チャットルーム名を変更', {name: message.name})}
                                </span>
                              </div>
          break
      }
    }
    else
      undefined

      return (
      <div ref={(c)=> this.component = c} onDoubleClick={reactionChat} >
        {!message.message_type &&
          <div className={classnames(chatMessageTheme.messageItem, direction)}
              onMouseEnter={this.onCloseButton}
              onMouseLeave={this.offCloseButton} >
            {direction == 'right' && this.state.active &&
                <FontIcon className={isStamp ? chatMessageTheme.closeButtonStamp : chatMessageTheme.closeButton}
                    value='close'
                    onClick={()=> this.setState({ isConfirm: true })} />
            }
            <ConfirmDialog title={t('label:メッセージを削除')}
                description={t('label:この操作は取り消せません')}
                open={this.state.isConfirm}
                onYes={this.deleteChatMessage}
                onNo={this.cancelDeleteMessage}
                yesLabel={t('label:削除')}
                noLabel={t('label:取り消し')} />
            {direction == 'left' &&
              <div>
                <Avatar className="chatIcon" image={message.user.icon_image.thumb_url} theme={avatarTheme} onClick={() => this.selectChatIcon(message.user,chatRoomMember) } />
              </div>
            }
            {direction == 'right' && message.readers && message.readers.length > 0 &&
              <div className={classnames(chatMessageTheme.readers)}>
                {t('label:既読n', { n: message.readers.length > 1 ? message.readers.length : '' })}
              </div>
            }
            <div className={chatMessageTheme.contentDiv}>
              {withName && direction == 'left' &&
                <div className={chatMessageTheme.user}>
                  {message.user.name || undefined}
                </div>
              }
              {!(isStamp || images.length > 0 || files.length > 0 || videos.length > 0 || audios.length > 0 || pdfs.length > 0) &&
                <div style={{ maxWidth: `${chatPageWidth * 0.7}`+'px' , display: 'inline-flex'}}
                className={classnames(chatMessageTheme.content, direction, direction == 'left' && withName && 'withName')} >
                  {htmlContent &&
                    <div 
                      className={chatMessageTheme.messageText}
                      dangerouslySetInnerHTML={{__html: htmlContent }} />
                  }
                  
                </div>
              }

              {isStamp &&
                <div dangerouslySetInnerHTML={{__html: htmlContent }} />
              }
              {pdfs.length > 0 && this.state.pdfThumbnail &&
                _.map(pdfs, (pdf)=>
                <div className={chatMessageTheme.pdfNameDiv}>
                  <img key={pdf.file_id} src={pdf.file.thumb_url} onClick={()=> this.showPdfPreview(pdf)}
                      className={classnames(chatMessageTheme.image, direction)}
                      onError={this.onPdfThumbnailError}
                      style={{ maxWidth: 0.8 * chatPageWidth, maxHeight: 300 }} />
                  <div className={chatMessageTheme.pdfName}>{pdf.name}</div>
                </div>
              )}
              {pdfs.length > 0 && !this.state.pdfThumbnail &&
                _.map(pdfs, (pdf)=>
                  <div><AttachmentFile key={pdf.file_id} file={pdf} noTooltip={true} chat={true} /></div>
              )}

              {images.length > 0 &&
                _.map(images, (image)=>
                  <img ref={(c)=> this.image = c}
                      key={image.file_id} src={image.file.url} onClick={()=> this.showImagesView(image)}
                      className={classnames(chatMessageTheme.image, direction)}
                      style={this.getSize(image, chatPageWidth)} />
              )}
              {videos.length > 0 &&
                _.map(videos, (video)=>
                  <div key={video.video_id}
                      className={classnames(chatMessageTheme.videoImageDiv)}
                      onClick={()=> this.showImagesView(video)} >
                    <img ref={(c)=> this.image = c}
                        onLoad={(ev)=> this.onLoad(ev, video)}
                        src={video.file.thumb_url}
                        className={classnames(chatMessageTheme.image, direction)}
                        style={this.state[`width${video.video_id}`] && this.state[`height${video.video_id}`] && this.getSize(video, chatPageWidth)} />
                    <div className={classnames(chatMessageTheme.playArrow, direction)} >
                      <Avatar icon="play_arrow" />
                    </div>
                  </div>
              )}
              {audios.length > 0 &&
                _.map(audios, (audio)=> {
                  const Component = audio.showTooltip ? TooltipLink : Link
                  return (<Component key={audio.video_id}
                        className={classnames(chatMessageTheme.videoImageDiv)}
                        tooltip={audio.name}
                        download={false}
                        theme={AttachmentsTheme}
                        style={{ display: 'inline' }}
                        onClick={()=> this.setState({ [`isPlay${audio.video_id}`]: true })} >
                      {!this.state[`isPlay${audio.video_id}`] &&
                        <Chip className={classnames(AttachmentsTheme.chip, 'audiotrack')}>
                          <Avatar className={classnames(AttachmentsTheme.avatar, 'audiotrack')} icon={'audiotrack'} />
                          {audio.filename}
                        </Chip>
                      }
                      {this.state[`isPlay${audio.video_id}`] &&
                        <VideoViewer video={audio} t={t} parent_component={'CHAT_MESSAGE'} onEnd={()=> this.setState({ [`isPlay${audio.video_id}`]: false })} />
                      }
                    </Component>
                  )
              })}
              {_.map(files, (file)=> {
                const Component = file.showTooltip ? TooltipLink : Link
                return (<Component key={file.file_id}
                      href={file.status ? undefined : file.file.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={direction == 'left' ? chatMessageTheme.file : undefined}
                      style={{ cursor: file.status && 'default' }}
                      tooltip={file.name}
                      download={!file.isPdf || file.status ? true : false}
                      theme={AttachmentsTheme}
                      style={{ display: 'inline' }} >
                    <Chip className={AttachmentsTheme.chipChat}
                        style={{ cursor: file.status && 'default' }} >
                      <Avatar className={file.status && file.status != 'committed' ? undefined : classnames(AttachmentsTheme.avatar, 'attach_file' )} icon={ "attach_file"} />
                      {file.filename}
                    </Chip>
                  </Component>
                )
              })}
              {
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {direction === 'left' &&  (
                    <span
                      className="material-icons"
                      onClick={this.handleReactclick}
                      style={{
                        position: 'relative',
                        color: isReacted
                          ? '#FEE876'
                          : 'white',
                        fontSize: 14,
                        paddingTop: 5,
                        marginLeft: 20,
                        cursor: 'pointer',
                        userSelect: 'none', // Prevent selection
                        WebkitUserSelect: 'none', // Safari support
                        MozUserSelect: 'none', // Firefox support
                        MsUserSelect: 'none', // IE/Edge support
                      }}
                    >
                      {isReacted ? 'thumb_up' : 'thumb_up_off_alt'}
                    </span>
                  )}
                  {likes_count > 0  && (
                    <TooltipButton
                      neutral={false}
                      ripple={false}
                      className={`touchable ${chatMessageTheme.chatReactions}`}
                      tooltipPosition="vertical"
                      tooltip={tooltip}
                      onDoubleClick={(e) => e.preventDefault()}
                      onClick={reactionChat}
                    >
                      {likesArray.length > 3
                        ? likesArray
                            .slice(likesArray.length - 3, likesArray.length)
                            .map((like) => (
                              <img
                                key={like.like_id}
                                style={{ height: 16, width: 16 }}
                                src={
                                  likeConfig &&
                                  emoji[likeConfig[like.like_type].icon.replace('\\u', '')]
                                }
                              />
                            ))
                        : likesArray.slice(0, 3).map((like) => (
                            <img
                              key={like.like_id}
                              style={{ height: 12, width: 12 }}
                              src={
                                likeConfig &&
                                emoji[likeConfig[like.like_type].icon.replace('\\u', '')]
                              }
                            />
                          ))}
                      &nbsp;{t('label:n', { n: likes_count })}
                    </TooltipButton>
                  )}
                </div>
              }
            </div>

            {ui.openDialog &&
              <div>
                <UserDetailsModal chatMessage
                    t={t}
                    user={ui.user}
                    current_user={user}
                    onClose={()=> updateUI({ user: undefined, openDialog: false })}
                    open={ui.openDialog}
                    individualChatRoom={individualChatRoom}/>
              </div>}
          </div> ||

          <span>{timeline_message}</span>
        }
      </div>
    )
  }
}

export default connect(ChatMessageItem)




// WEBPACK FOOTER //
// ./src/web/components/chat-message-item.jsx